import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { ToastProvider } from "./notifications/Toast";
import { translate as defaultTranslate } from "./utils/translate";
export const ThemeProviderContext = createContext({
    defaultButtonShape: "square",
    translate: defaultTranslate,
    locale: "en-us",
    currencyCode: "USD",
    testAttribute: "data-test",
});
export const ThemeProvider = ({ children, defaultButtonShape, menuZIndex, translate = defaultTranslate, locale = "en-us", currencyCode = "USD", testAttribute = "data-test", }) => {
    return (_jsx(ThemeProviderContext.Provider, { value: {
            defaultButtonShape,
            menuZIndex,
            translate,
            testAttribute,
            locale,
            currencyCode,
        }, children: _jsx(ToastProvider, { children: children }) }));
};
//# sourceMappingURL=ThemeProvider.js.map